import { FeatureType as DbFeatureType } from "@gql/generated/graphql";

/**
 * TODO: We should take this from backend so we define it once
 *
 * Manually defined Flagsmith feature names
 */
export enum FlagsmithFeatureType {
  CAMPAIGN_SIGNUP_LINK = "campaign_signup_link",
  VIDEO_PLAYER_READY_EVENT = "video_player_ready_event",
  TISCON_AI_COACHING_DEMO = "tiscon_ai_coaching_demo",
  CAMPAIGN_ASSISTANT = "campaign_assistant",
  GIBBERISH_TEXT_CHECK = "gibberish_text_check",
  INTERJECTIONS_HANDLING = "interjections_handling",
  WORD_CLOUD = "word_cloud",
  HOMEPAGE_2024 = "homepage_2024",
  ADMIN_NEW_CAMPAIGN_UI = "admin_new_campaign_ui",
  RENDER_LINKS_AS_ANCHOR = "render_links_as_anchor",
  NEW_CAMPAIGNS_PAGE = "new_campaigns_page",
  SPRINGAI_NEW_UX = "springai_new_ux",
  CONVERSATION_AI = "conversation_ai",
  MULTI_SELECT_FORMS = "multi_select_forms",
  ADMIN_GALLERY_REDESIGN = "admin_gallery_redesign",
  SENTIMENT_UI = "sentiment_ui",
  NEW_AUTH = "new_auth",
  ANONYMIZE_ADMIN_ANALYTICS = "anonymize_admin_analytics",
  AI_CHAT = "ai_chat",
  ROLE_PLAY_REP = "role_play_rep",
  ADMIN_NAV_REVAMP = "admin_nav_revamp",
  PDG_PAGE_TIME = "pdf_page_time",
}

export const FeatureType = {
  ...DbFeatureType,
  ...FlagsmithFeatureType,
};

export type FeatureType = DbFeatureType | FlagsmithFeatureType;
